import { ContactBlock } from "../components/ContactBlock";
import { SEO } from "../components/SEO";
import { useContent } from "../lib/content";
import { resolveImage } from "../lib/realisations";
import { heroCardStyle } from "../lib/heroCard";

export default function Contact() {
  const c = useContent("contact");
  return (
    <div data-testid="page-contact">
      <SEO path="/contact" title="Contact — ECO-GEST PATRIMOINE | Marigny-Saint-Marcel" description="Contactez ECO-GEST PATRIMOINE pour votre projet : 10 impasse de la Maison Blanche, 74150 Marigny-Saint-Marcel — 06 60 81 65 49. Réponse sous 24h ouvrées." />
      <section className="relative h-[50vh] min-h-[360px] bg-[#1A1A1A] text-white overflow-hidden flex items-end">
        <img src={resolveImage(c.hero_image)} alt="" className="absolute inset-0 w-full h-full object-cover" style={{ opacity: ((c.hero_image_opacity ?? 100) / 100) }} />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pb-14 w-full">
          <div
            className="inline-block border-l-2 border-[#E60000] rounded-r-lg px-6 py-5 shadow-xl shadow-black/15"
            style={heroCardStyle(c)}
          >
            <p className="inline-flex items-center gap-3 text-xs md:text-sm font-bold tracking-[0.25em] uppercase text-white">
              <span className="inline-block w-8 h-px bg-[#E60000]" />
              {c.hero_breadcrumb}
            </p>
            <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[0.95] text-white mt-3">{c.hero_title}</h1>
          </div>
        </div>
      </section>

      <ContactBlock showTitle={false} />
    </div>
  );
}
